import React, { createContext, useContext } from 'react';
import { initializeApp } from '@firebase/app';
import { getAnalytics, logEvent } from '@firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBo3eeGh6bfOYAwVdO4O0HuxFXYo7-YZH4',
  authDomain: 'invertible-oath-312218.firebaseapp.com',
  projectId: 'invertible-oath-312218',
  storageBucket: 'invertible-oath-312218.appspot.com',
  messagingSenderId: '98681881662',
  appId: '1:98681881662:web:8b1f295c19e50bf3723d6f',
  measurementId: 'G-SBGWCD5XEM',
};

const app = initializeApp(firebaseConfig);

const AnalyticsContext = createContext<{ logEvent: (eventName: string, params?: Record<string, any>) => void } | undefined>(
  undefined,
);

export const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const analytics = getAnalytics(app);

  const logCustomEvent = (eventName: string, params?: Record<string, any>) => {
    logEvent(analytics, eventName, params);
  };

  return <AnalyticsContext.Provider value={{ logEvent: logCustomEvent }}>{children}</AnalyticsContext.Provider>;
};

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};
